// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2pnuh","header":"ReportDetails_header__1hKCX","title":"ReportDetails_title__27CyC","left":"ReportDetails_left__2-5tx"};